const contactItems = [
  {
    icon: "ri-map-pin-2-line",
    label: "Address",
    value: "2 Targovska str.",
  },
  {
    icon: "ri-building-2-line",
    label: "City",
    value: "Lovech",
  },
  {
    icon: "ri-mail-line",
    label: "Email",
    value: "help@montanaood.com",
  },
  {
    icon: "ri-map-2-line",
    label: "Zip Code",
    value: "5500",
  },
  {
    icon: "ri-flag-line",
    label: "Country",
    value: "Bulgaria",
  },
  {
    icon: "ri-phone-line",
    label: "Phone",
    value: "+1 6626763874",
  },
];

export default function Contact() {
  return (
    <section id="contact" className="bg-[#14161E] py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Top row */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10 mb-16">
          <div>
            <span className="inline-block text-xs font-semibold tracking-[0.2em] uppercase text-white/40 mb-4">
              Get In Touch
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Contact Us
            </h2>
            <div className="w-16 h-0.5 bg-emerald-400" />
          </div>
          <p className="text-white/50 text-base max-w-md leading-relaxed">
            Have questions about our products or want to learn more about
            MONTANA OOD? We&apos;d love to hear from you.
          </p>
        </div>

        {/* Contact grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {contactItems.map((item) => (
            <div
              key={item.label}
              className="bg-white/5 border border-white/10 rounded-2xl p-6 flex items-start gap-4"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-emerald-400/15 border border-emerald-400/25 flex-shrink-0">
                <i className={`${item.icon} text-emerald-400 text-base`} />
              </div>
              <div>
                <p className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-1">
                  {item.label}
                </p>
                <p className="text-white text-base font-medium">{item.value}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <img
              src="https://public.readdy.ai/ai/img_res/7870f51d-e5a2-48e2-b603-e53d2018e600.png"
              alt="MONTANA OOD"
              className="h-7 w-auto object-contain opacity-70"
            />
            <span className="text-white/50 text-sm font-medium">MONTANA OOD</span>
          </div>
          <p className="text-white/30 text-sm text-center">
            &copy; {new Date().getFullYear()} MONTANA OOD. All rights reserved.
          </p>
        </div>
      </div>
    </section>
  );
}
